import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import "devextreme-react/text-area";
import {
  inserirOuAtualizar,
  criarUsuariosDs,
  criarCpbsDs,
  criarPrefeituraDs,
  criarContribuinteDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import CpbsBox from "../cpbs/CpbsBox";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import Memoria from "../../Memoria";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;
const data = new Date();

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  login: undefined,
  senha: undefined,
  nome: undefined,
  cpfCnpj: undefined,
  perfil: undefined,
  subPerfil: undefined,
  ativo: true,
  administrador: undefined,
  online: undefined,
  cpbsId: undefined,
  contribuinteId: undefined,
  _uiSequencialContribuinte: undefined,
  inscricao: undefined,
  dataDeAtualizacao: data,
  popupContribuinteVisivel: false,
  popupCpbsVisivel: false,
  popupSenha: false,
};

export default class UsuariosForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...(_cadastroCorrente || template) };
    this.usuariosDs = criarUsuariosDs();
    this.cpbsDs = criarCpbsDs();
    this.contribuinteDs = criarContribuinteDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.prefeituraOptions = {
      showClearButton: true,
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarPrefeituraDs(),
      valueExpr: "id",
      displayExpr: "prefeituraTopo",
      searchMode: "contains",
    };

    this.perfilOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: "trimap", descricao: "Usuário Trimap" },
        { id: "prefeitura", descricao: "Prefeitura" },
        { id: "contribuinte", descricao: "Contribuinte" },
        { id: "cpbs", descricao: "CPBS" },
        { id: "cartorio", descricao: "Cartório de Protestos" },
        { id: "vigilancia_sanitaria", descricao: "Vigilância Sanitária" },
        { id: "licitacao", descricao: "Licitação" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.subPerfilOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: "", descricao: "Nenhum" },
        { id: "adm", descricao: "Administrador" },
        { id: "obras", descricao: "Obras" },
        { id: "contabilidade", descricao: "Contabilidade" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    //Funções do contribuinte
    /*
    /*
    */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state._uiSequencialContribuinte,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    /*
  /*
  */
    //Fim da funções do contribuinte

    //Funções do cpbs
    /*
    /*
    */
    this.setCpbsId = this.setCpbsId.bind(this);
    this.pesquisarCpbs = this.pesquisarCpbs.bind(this);
    this.onCpbsSelecionadoPesquisa = this.onCpbsSelecionadoPesquisa.bind(this);
    this.cpbsBoxRef = React.createRef();
    this.renderCpbs = sysCodigoDescricao(
      () => this.state.inscricao,
      this.setCpbsId,
      () => this.state._uiNomeCpbs,
      this.pesquisarCpbs
    );
    /*
   /*
   */
    //Fim da funções do cpbs
  }

  //Funções do contribuinte
  /*
  /*
  */

  setContribuinteId({ value }) {
    this.contribuinteDs
      .load({
        filter: [["sequencial", "=", value]],
      })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({
              _uiNomeContribuinte: "",
              popupContribuinteVisivel: false,
            });
          } else {
            this.setState({
              _uiNomeContribuinte: result[0].nome,
              _uiSequencialContribuinte: result[0].sequencial,
              contribuinteId: result[0].id,
              popupContribuinteVisivel: false,
            });
          }
        } else {
          this.setState({ popupContribuinteVisivel: false });
        }
      })
      .catch((_) => this.setState({ _uiNomeContribuinte: "<<ERRO>>" }));
  }

  onContribuinteSelecionadoPesquisa(e) {
    let dados = { value: e.row.data.sequencial };
    this.setContribuinteId(dados);
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupContribuinteVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do contribuinte

  //Funções do cpbs
  /*
  /*
  */

  setCpbsId({ value }) {
    this.cpbsDs
      .load({
        filter: [["inscricao", "=", value]],
      })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            this.setState({ _uiNomeCpbs: "", popupCpbsVisivel: false });
          } else {
            this.setState({
              _uiNomeCpbs: result[0].contribuinte.nome,
              inscricao: result[0].inscricao.toString(),
              cpbsId: result[0].id,
              popupCpbsVisivel: false,
            });
          }
        } else {
          this.setState({ popupCpbsVisivel: false });
        }
      })
      .catch((_) => this.setState({ _uiNomeContribuinte: "<<ERRO>>" }));
  }

  onCpbsSelecionadoPesquisa(e) {
    let dados = { value: e.row.data.inscricao };
    this.setCpbsId(dados);
  }

  pesquisarCpbs() {
    this.cpbsBoxRef.current.limparFiltro();
    this.setState({ popupCpbsVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do cpbs

  componentDidMount() {
    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.usuariosDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Usuário não encontrado.", "error");
              this.props.history.push("/usuarios");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2} labelLocation={"top"}>
            <GroupItem caption="DADOS DE USUÁRIO" colSpan={2} colCount={4}>
              <SimpleItem dataField={"nome"} colSpan={2}>
                <Label text="Nome" />
              </SimpleItem>
              <SimpleItem dataField={"login"} colSpan={1}>
                <Label text="Login" />
              </SimpleItem>
              <SimpleItem
                dataField={"senha"}
                editorOptions={{
                  readOnly:
                    this.props.match.params.id !== undefined ? false : true,
                  mode: "password",
                }}
                colSpan={1}
              >
                <Label text="Senha" />
              </SimpleItem>
              <SimpleItem
                dataField={"prefeituraId"}
                editorType={"dxLookup"}
                editorOptions={this.prefeituraOptions}
                colSpan={2}
              >
                <Label text="Prefeitura" />
              </SimpleItem>
              <SimpleItem dataField={"cpfCnpj"} colSpan={1}>
                <Label text="Documento" />
              </SimpleItem>
              <SimpleItem dataField={"email"} colSpan={1}>
                <Label text="E-mail" />
              </SimpleItem>
              <SimpleItem colSpan={4} component={this.renderContribuinte}>
                <Label text="Contribuinte" />
              </SimpleItem>
              <SimpleItem colSpan={4} component={this.renderCpbs}>
                <Label text="CPBS" />
              </SimpleItem>
              <SimpleItem
                dataField={"perfil"}
                editorType={"dxLookup"}
                editorOptions={this.perfilOptions}
                colSpan={2}
              >
                <Label text="Perfil" />
              </SimpleItem>
              <SimpleItem
                dataField={"subPerfil"}
                editorType={"dxLookup"}
                editorOptions={this.subPerfilOptions}
                colSpan={2}
              >
                <Label text="Sub-Perfil" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxCheckBox"}
                dataField={"administrador"}
                colSpan={1}
              >
                <Label text="Administrador" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxCheckBox"}
                dataField={"ativo"}
                editorOptions={{
                  readOnly:
                    this.props.match.params.id !== undefined ? false : true,
                }}
                colSpan={1}
              >
                <Label text="Ativo" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="default"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupCpbsVisivel}
          onHiding={() => this.setState({ popupCpbsVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar CPBS"
        >
          <ScrollView showScrollbar={"always"}>
            <CpbsBox
              onSelecionado={this.onCpbsSelecionadoPesquisa}
              ref={this.cpbsBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupCpbsVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupSenha}
          onHiding={() => this.setState({ popupSenha: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"30%"}
          height={"30%"}
          title="Senha"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3>Guarde sua senha:</h3>
            <p>
              <strong>{this.state.senha}</strong>
            </p>
          </div>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Finalizar",
              type: "default",
              width: 150,
              onClick: () => this.props.history.goBack(),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupContribuinteVisivel}
          onHiding={() => this.setState({ popupContribuinteVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupContribuinteVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    const entidade =
      this.props.match.params.id === undefined
        ? {
            ...this.state,
            dataDeAtualizacao: data,
            dataDeCadastro: data,
            online: true,
          }
        : { ...this.state, dataDeAtualizacao: data, online: true };
    inserirOuAtualizar(this.usuariosDs, entidade)
      .then(
        function (response) {
          notify("Usuário cadastrado com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          if (this.props.match.params.id === undefined) {
            this.setState({ senha: response.senha, popupSenha: true });
          } else {
            this.props.history.goBack();
          }
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
